import { render, staticRenderFns } from "./SiteItemsView.vue?vue&type=template&id=33ed77dc&scoped=true&"
import script from "./SiteItemsView.vue?vue&type=script&lang=js&"
export * from "./SiteItemsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ed77dc",
  null
  
)

export default component.exports